import React, { useContext, useEffect } from "react";
import { store } from "../../store.js";
import Label from "../Commands/Label/Label";
import Panel from "../Commands/Panel/Panel";
import TabPanel from "../Commands/TabPanel/TabPanel";
import DataGrid from "../Commands/DataGrid/DataGrid";
import SearchGrid from "../Commands/DataGrid/SearchGrid";
import Header from "../Commands/DataGrid/Header";
import Filter from "../Commands/DataGrid/Filter"
import Rows from "../Commands/DataGrid/Rows";
import CheckBoxLabel from "../Commands/CheckBoxLabel/CheckBoxLabel";
import Attachment from "../Commands/Attachment/Attachment";
import Radio from "../Commands/Radio/Radio";
import Line from "../Commands/Line/Line";
import HyperText from "../Commands/HyperText/HyperText";
import ListBox from "../Commands/ListBox/ListBox";
import ListView from "../Commands/ListView/ListView";
import SplitListView from "../Commands/SplitListView/SplitListView";
import TreeBox from "../Commands/TreeBox/TreeBox";
import TextBox from "../Commands/TextBox/TextBox";
import RichTextBox from "../Commands/RichTextBox/RichTextBox";
import DateTime from "../Commands/DateTime/DateTime";
import Button from "../Commands/Button/Button"; 
import ToolBarMenu from "../Commands/ToolBarMenu/ToolBarMenu";
import SideBarMenu from "../Commands/SideBarMenu/SideBarMenu";
import useKeyPress from "../../Hooks/useKeyPress";
import useDeleteSourceOccurence from "../../Hooks/useDeleteSourceOccurence";
import AutoCompletListBox from "../Commands/AutoCompletListBox/AutoCompletListBox.js";
import TextEditor from "../Commands/TextEditor/TextEditor.js";


export default function ToolComponent(props) {
  const globalState = useContext(store);
  const { dispatch } = globalState;
  const DeletePressed = useKeyPress(46);
  const CtrlPressed = useKeyPress(17);
  const deleteSourceOccurence = useDeleteSourceOccurence();
  const currentToolIds = globalState.state.formData.currentTool.map(item=> item.id);
  
  const contextMenus = [{ id: 1, item:"Vertical Alignment" }, { id: 1, item:"Horizontal Alignment" }, { id: 1, item:"Delete" }]
 
  const onSelectRow = (updatedFormData, template) => {
    
    if (!template.dataGridId) return
    
    
    if (!template.rowTemplate) return
    if (!updatedFormData.currentRow) {
      updatedFormData.currentRow = [{dataGridId:template.dataGridId, ...template.rowTemplate}]
    }
    else { //if (updatedFormData.currentRow.filter(row => row.gridId == props.data.id && row.row.id == template.id).length == 0) {
      updatedFormData.currentRow = updatedFormData.currentRow.filter(row => row.dataGridId != template.dataGridId)
      updatedFormData.currentRow.push({dataGridId:template.dataGridId, ...template.rowTemplate})
      
    }
    
    
  };

  const onClick = (e, template) => {
   
    var alreadyClick = currentToolIds.includes(template.id);
    
    if ( !alreadyClick || CtrlPressed.keyPressed || 
      
        (!globalState.state.formData.currentRow || globalState.state.formData.currentRow.filter(row => row.dataGridId != template.dataGridId).length ==0)
      ) {
      
      var updatedFormData = JSON.parse(JSON.stringify(globalState.state.formData));

      if (CtrlPressed.keyPressed == true){
        if (alreadyClick)
          updatedFormData.currentTool = updatedFormData.currentTool.filter(item => item.id != template.id);
        else
          updatedFormData.currentTool.push(template);
      }
      else
        updatedFormData.currentTool = [template];
        
      onSelectRow(updatedFormData, template)
    
      dispatch({
        type: "UPDATE_FORM_WITOUT_HISTORIQUE",
        payload: updatedFormData,
      });
           
      props.onClick(e, template)
    } 


   
    e.stopPropagation();
  };

  const getStyle = (meta) => {
    var newStyle = JSON.parse(JSON.stringify(meta.styles));
    newStyle["position"] = {value:props.position ? props.position : "absolute"};
    var isSelected = currentToolIds.includes(meta.id);
    
    newStyle["border"] =  {value:props.draggable && isSelected ? "1px dashed gray" : meta.styles.border && meta.styles.border.value};
    if (!props.draggable) newStyle["resize"] = "none"
    if (props.dataGridColumn == true) {
      delete newStyle.top;
      delete newStyle.left;
    }

    
    return newStyle;
  };
  
  useEffect(() => {
    
    !globalState.state.formData.isEditTool && deleteCurrentsControls();
  }, [DeletePressed.keyPressed]);


  const deleteCurrentsControls = () => {
    if (!props.draggable) return
    if (DeletePressed.keyPressed == true) {
      
      var updatedFormData = JSON.parse(JSON.stringify(globalState.state.formData));

      const formId = 1
      var currentToolIdsWithOutForm = currentToolIds.filter(item=> item !== formId);
      
      deleteSourceOccurence(updatedFormData, currentToolIdsWithOutForm);
      DeletePressed.upHandler(DeletePressed.event);

      updatedFormData.currentTool[0].styles = {};
      updatedFormData.currentTool[0].properties = {};
      
      dispatch({
        type: "UPDATE_FORM",
        payload: updatedFormData,
      });
    }
  };
  const getItem = (meta) => {
    switch (meta.type) {
      case "Label":
        return (
          <Label
            data={meta}
            style={getStyle(meta)}
            onClick={(e) => onClick(e, meta)}
            draggable={props.draggable}
            sortable={props.sortable}
            onlyLabel={props.onlyLabel}
            onDropColumn={(e, column) => props.onDropColumn(e, column)}
            contextMenus={contextMenus}
            onDragStart={(e) => props.onDragStart(e)}
            updateSize ={(id, resizeWidth, resizeHeight) =>  props.updateSize(id, resizeWidth, resizeHeight)}
          />
        );
      case "GroupBox":
        return (
          <Panel
            data={meta}
            style={getStyle(meta)}
            onClick={(e) => onClick(e, meta)}
            isSelected={currentToolIds.includes(meta.id)}
            draggable={props.draggable}
            contextMenus={contextMenus}
            onDragStart={(e) => props.onDragStart(e)}
            handleOnDrop={(updatedFormData,containerId, template, schema) => 
              props.handleOnDrop(updatedFormData,containerId, template, schema)}
            updateSize ={(id, resizeWidth, resizeHeight) =>  props.updateSize(id, resizeWidth, resizeHeight)}
            onChange={(e, value) => props.onChange(e, value)}
            onKeyPress={(e) => props.onKeyPress(e)}
            onBlur={(e, currentTemplate) => props.onBlur(e, currentTemplate)}
            //onMouseOver={(e, currentTemplate) => props.onMouseOver(e, currentTemplate)}
            onMouseEnter={(e, currentTemplate) => props.onMouseEnter(e, currentTemplate)}
            onMouseDown={(e, currentTemplate) => props.onMouseDown(e, currentTemplate)}
            onMouseLeave={(e, currentTemplate) => props.onMouseLeave(e, currentTemplate)}
          />
        );
      case "Panel":
          return (
            <Panel
               isTabPanel={true}
              data={meta}
              style={getStyle(meta)}
              onClick={(e, currentTemplate) => onClick(e, currentTemplate)}
              isSelected={currentToolIds.includes(meta.id)}
              draggable={props.draggable}
              contextMenus={contextMenus}
              onDragStart={(e) => props.onDragStart(e)}
              handleOnDrop={(updatedFormData,containerId, template, schema) => 
                props.handleOnDrop(updatedFormData,containerId, template, schema)}
              updateSize ={(id, resizeWidth, resizeHeight) =>  props.updateSize(id, resizeWidth, resizeHeight)}
              //onChange={(e, value) => props.onChange(e, e ? e.target.value : value)}
              onChange={(e, value) => props.onChange(e, value)}
              onKeyPress={(e) => props.onKeyPress(e)}
              onBlur={(e, currentTemplate) => props.onBlur(e, currentTemplate)}
              //onMouseOver={(e, currentTemplate) => props.onMouseOver(e, currentTemplate)}
              onMouseEnter={(e, currentTemplate) => props.onMouseEnter(e, currentTemplate)}
              onMouseDown={(e, currentTemplate) => props.onMouseDown(e, currentTemplate)}
              onMouseLeave={(e, currentTemplate) => props.onMouseLeave(e, currentTemplate)}
            />
          );
      case "TabPanel":
        return (
            <TabPanel
              data={meta}
              draggable={props.draggable}
              style={getStyle(meta)}
              onClick={(e, currentTemplate) => onClick(e, currentTemplate)}
              contextMenus={contextMenus}
              onDragStart={(e) => props.onDragStart(e)}
              handleOnDrop={(updatedFormData,containerId, template, schema) => 
                props.handleOnDrop(updatedFormData,containerId, template, schema)}
              updateSize ={(id, resizeWidth, resizeHeight) =>  props.updateSize(id, resizeWidth, resizeHeight)}
              //onChange={(e) => props.onChange(e)}
              onChange={(e, value) => props.onChange(e, value)}
              onKeyPress={(e) => props.onKeyPress(e)}
              onBlur={(e, currentTemplate) => props.onBlur(e, currentTemplate)}
              //onMouseOver={(e, currentTemplate) => props.onMouseOver(e, currentTemplate)}
              onMouseEnter={(e, currentTemplate) => props.onMouseEnter(e, currentTemplate)}
              onMouseDown={(e, currentTemplate) => props.onMouseDown(e, currentTemplate)}
              onMouseLeave={(e, currentTemplate) => props.onMouseLeave(e, currentTemplate)}  
            />
          );
      case "ListView":
        return (
            <ListView
              data={meta}
              draggable={props.draggable}
              style={getStyle(meta)}
              contextMenus={contextMenus}
              onDragStart={(e) => props.onDragStart(e)}
              onChange={(e, value) => props.onChange(e, value)}
              handleOnDrop={(updatedFormData,containerId, template, schema) => 
                props.handleOnDrop(updatedFormData,containerId, template, schema)}
              updateSize ={(id, resizeWidth, resizeHeight) =>  props.updateSize(id, resizeWidth, resizeHeight)}
              onClick={(e, currentTemplate) => onClick(e, currentTemplate)}
              onBlur={(e, currentTemplate) => props.onBlur(e, currentTemplate)}
              //onMouseOver={(e, currentTemplate) => props.onMouseOver(e, currentTemplate)}
              onMouseEnter={(e, currentTemplate) => props.onMouseEnter(e, currentTemplate)}
              onMouseDown={(e, currentTemplate) => props.onMouseDown(e, currentTemplate)}
              onMouseLeave={(e, currentTemplate) => props.onMouseLeave(e, currentTemplate)}
            />
          );
      case "SplitListView":
        return (
            <SplitListView
              data={meta}
              draggable={props.draggable}
              style={getStyle(meta)}
              contextMenus={contextMenus}
              onDragStart={(e) => props.onDragStart(e)}
              onChange={(e, value) => props.onChange(e, value)}
              handleOnDrop={(updatedFormData,containerId, template, schema) => 
                props.handleOnDrop(updatedFormData,containerId, template, schema)}
              updateSize ={(id, resizeWidth, resizeHeight) =>  props.updateSize(id, resizeWidth, resizeHeight)}
              onClick={(e, currentTemplate) => onClick(e, currentTemplate)}
              onBlur={(e, currentTemplate) => props.onBlur(e, currentTemplate)}
              //onMouseOver={(e, currentTemplate) => props.onMouseOver(e, currentTemplate)}
              onMouseEnter={(e, currentTemplate) => props.onMouseEnter(e, currentTemplate)}
              onMouseDown={(e, currentTemplate) => props.onMouseDown(e, currentTemplate)}
              onMouseLeave={(e, currentTemplate) => props.onMouseLeave(e, currentTemplate)}
            />
          );
      case "Attachment":
        return (
          <Attachment
            data={meta}
            style={getStyle(meta)}
            onClick={(e) => onClick(e, meta)}
            draggable={props.draggable}
            onlyLabel={props.onlyLabel}
            sortable={props.sortable}
            onDropColumn={(e, column) => props.onDropColumn(e, column)}
            contextMenus={contextMenus}
            onDragStart={(e) => props.onDragStart(e)}
            updateSize ={(id, resizeWidth, resizeHeight) =>  props.updateSize(id, resizeWidth, resizeHeight)}
            //onMouseOver={(e) => props.onMouseOver(e, meta)}
            onMouseEnter={(e) => props.onMouseEnter(e, meta)}
            onMouseDown={(e) => props.onMouseDown(e, meta)}
            onMouseLeave={(e) => props.onMouseLeave(e, meta)}
            errors = {globalState.state.formData.errors.filter(item => item.id == meta.id)[0]}
          />
        );
      case "CheckBoxLabel":
        return (
          <CheckBoxLabel
            data={meta}
            style={getStyle(meta)}
            onClick={(e) => onClick(e, meta)}
            onClickSearchIcon={(e) => props.onClickSearchIcon(e)}
            draggable={props.draggable}
            onlyLabel={props.onlyLabel}
            dataGridColumn={props.dataGridColumn}
            sortable={props.sortable}
            filterable={props.filterable}
            onDropColumn={(e, column) => props.onDropColumn(e, column)}
            contextMenus={contextMenus}
            onDragStart={(e) => props.onDragStart(e)}
            onChange={(value) => props.onChange(undefined, value)}
            updateSize ={(id, resizeWidth, resizeHeight) =>  props.updateSize(id, resizeWidth, resizeHeight)}
          />
        );
      case "ListBox":
        return (
          <ListBox
            data={meta}
            style={getStyle(meta)}
            onClick={(e) => onClick(e, meta)}
            draggable={props.draggable}
            onlyLabel={props.onlyLabel}
            sortable={props.sortable}
            onDropColumn={(e, column) => props.onDropColumn(e, column)}
            onChange={(undefined, itemSelected) => props.onChange(undefined, itemSelected)}
            contextMenus={contextMenus}
            onDragStart={(e) => props.onDragStart(e)}
            updateSize ={(id, resizeWidth, resizeHeight) =>  props.updateSize(id, resizeWidth, resizeHeight)}
            //onMouseOver={(e) => props.onMouseOver(e, meta)}
            onMouseEnter={(e) => props.onMouseEnter(e, meta)}
            onMouseDown={(e) => props.onMouseDown(e, meta)}
            onMouseLeave={(e) => props.onMouseLeave(e, meta)}
            errors = {globalState.state.formData.errors.filter(item => item.id == meta.id)[0]}
          />
        );
      case "MenuItem":
        return (
          <ListBox
            data={meta}
            style={getStyle(meta)}
            onClick={(e) => onClick(e, meta)}
            draggable={props.draggable}
            onlyLabel={props.onlyLabel}
            sortable={props.sortable}
            onDropColumn={(e, column) => props.onDropColumn(e, column)}
            onChange={(itemSelected) => props.onChange(undefined, itemSelected)}
            contextMenus={contextMenus}
            onDragStart={(e) => props.onDragStart(e)}
            updateSize ={(id, resizeWidth, resizeHeight) =>  props.updateSize(id, resizeWidth, resizeHeight)}
            //onMouseOver={(e) => props.onMouseOver(e, meta)}
            onMouseEnter={(e) => props.onMouseEnter(e, meta)}
            onMouseDown={(e) => props.onMouseDown(e, meta)}
            onMouseLeave={(e) => props.onMouseLeave(e, meta)}
            errors = {globalState.state.formData.errors.filter(item => item.id == meta.id)[0]}
          />
        );
      case "TreeBox":
        return (
          <TreeBox
            data={meta}
            style={getStyle(meta)}
            onClick={(e) => onClick(e, meta)}
            draggable={props.draggable}
            onlyLabel={props.onlyLabel}
            sortable={props.sortable}
            onDropColumn={(e, column) => props.onDropColumn(e, column)}
            contextMenus={contextMenus}
            onDragStart={(e) => props.onDragStart(e)}
            onChange={(e, value) => props.onChange(e, value)}
            updateSize ={(id, resizeWidth, resizeHeight) =>  props.updateSize(id, resizeWidth, resizeHeight)}
          />
        );
      case "AutoComplete":
        
        return (
          <AutoCompletListBox
            data={meta}
            style={getStyle(meta)}
            onClick={(e) => onClick(e, meta)}
            draggable={props.draggable}
            onlyLabel={props.onlyLabel}
            sortable={props.sortable}
            onDropColumn={(e, column) => props.onDropColumn(e, column)}
            contextMenus={contextMenus}
            onDragStart={(e) => props.onDragStart(e)}
            onChange={(e, itemSelected) => props.onChange(e, itemSelected)}
            updateSize ={(id, resizeWidth, resizeHeight) =>  props.updateSize(id, resizeWidth, resizeHeight)}
            //onMouseOver={(e) => props.onMouseOver(e, meta)}
            onMouseEnter={(e) => props.onMouseEnter(e, meta)}
            onMouseDown={(e) => props.onMouseDown(e, meta)}
            onMouseLeave={(e) => props.onMouseLeave(e, meta)}
            errors = {globalState.state.formData.errors.filter(item => item.id == meta.id)[0]}
          />
          );
      case "HyperText":
        return (
          <HyperText
            data={meta}
            style={getStyle(meta)}
            onClick={(e) => onClick(e, meta)}
            draggable={props.draggable}
            onlyLabel={props.onlyLabel}
            sortable={props.sortable}
            onDropColumn={(e, column) => props.onDropColumn(e, column)}
            contextMenus={contextMenus}
            onDragStart={(e) => props.onDragStart(e)}
            updateSize ={(id, resizeWidth, resizeHeight) =>  props.updateSize(id, resizeWidth, resizeHeight)}
            //onMouseOver={(e) => props.onMouseOver(e, meta)}
            onMouseEnter={(e) => props.onMouseEnter(e, meta)}
            onMouseDown={(e) => props.onMouseDown(e, meta)}
            onMouseLeave={(e) => props.onMouseLeave(e, meta)}
            errors = {globalState.state.formData.errors.filter(item => item.id == meta.id)[0]}
          />
        );
      case "DateTime":
        
        return (
          <DateTime
            data={meta}
            style={getStyle(meta)}
            onClick={(e) => onClick(e, meta)}
            onClickSearchIcon={(e) => props.onClickSearchIcon(e)}
            draggable={props.draggable}
            onlyLabel={props.onlyLabel}
            sortable={props.sortable}
            filterable={props.filterable}
            onDropColumn={(e, column) => props.onDropColumn(e, column)}
            contextMenus={contextMenus}
            onDragStart={(e) => props.onDragStart(e)}
            onChange={(e, value) => props.onChange(e, value)}
            updateSize ={(id, resizeWidth, resizeHeight) =>  props.updateSize(id, resizeWidth, resizeHeight)}
            errors = {globalState.state.formData.errors.filter(item => item.id == meta.id)[0]}
          />
        );
      case "Radio":
        return (
          <Radio
            data={meta}
            style={getStyle(meta)}
            onClick={(e) => onClick(e, meta)}
            draggable={props.draggable}
            onlyLabel={props.onlyLabel}
            contextMenus={contextMenus}
            onDragStart={(e) => props.onDragStart(e)}
            onChange={(value) => props.onChange(undefined, value)}
            updateSize ={(id, resizeWidth, resizeHeight) =>  props.updateSize(id, resizeWidth, resizeHeight)}
          />
        );
      case "Line":
        return (
          <Line
            data={meta}
            isSelected={currentToolIds.includes(meta.id)}
            style={getStyle(meta)}
            onClick={(e) => onClick(e, meta)}
            draggable={props.draggable}
            contextMenus={contextMenus}
            onDragStart={(e) => props.onDragStart(e)}
            updateSize ={(id, resizeWidth, resizeHeight) =>  props.updateSize(id, resizeWidth, resizeHeight)}
          />
        );
      case "TextBox":
        
        return (
          <TextBox
            data={meta}
            style={getStyle(meta)}
            onClick={(e) => onClick(e, meta)}
            onClickSearchIcon={(e) => props.onClickSearchIcon(e)}
            draggable={props.draggable}
            onlyLabel={props.onlyLabel}
            isSelected={currentToolIds.includes(meta.id)}
            dataGridColumn={props.dataGridColumn}
            sortable={props.sortable}
            filterable={props.filterable}
            onDropColumn={(e, column) => props.onDropColumn(e, column)}
            contextMenus={contextMenus}
            onDragStart={(e) => props.onDragStart(e)}
            updateSize ={(id, resizeWidth, resizeHeight) =>  props.updateSize(id, resizeWidth, resizeHeight)}
            onChange={(e, value) => props.onChange(e, value)}
            onKeyPress={(e) => props.onKeyPress(e)}
            onBlur={(e) => props.onBlur(e, meta)}
            //onMouseOver={(e) => props.onMouseOver(e, meta)}
            onMouseEnter={(e) => props.onMouseEnter(e, meta)}
            onMouseDown={(e) => props.onMouseDown(e, meta)}
            onMouseLeave={(e) => props.onMouseLeave(e, meta)}
            errors = {globalState.state.formData.errors.filter(item => item.id == meta.id)[0]}
          />
        );
      case "TextEditor":
        return (
          <TextEditor
            data={meta}
            style={getStyle(meta)}
            onClick={(e) => onClick(e, meta)}
            draggable={props.draggable}
            contextMenus={contextMenus}
            onDragStart={(e) => props.onDragStart(e)}
            onChange={(value) => props.onChange(undefined, value)}
            updateSize ={(id, resizeWidth, resizeHeight) =>  props.updateSize(id, resizeWidth, resizeHeight)}
            errors = {globalState.state.formData.errors.filter(item => item.id == meta.id)[0]}
          />
        );
      case "RichTextBox":
        return (
          <RichTextBox
            data={meta}
            style={getStyle(meta)}
            onClick={(e) => onClick(e, meta)}
            onChange={(e, value) => props.onChange(e, value)}
            draggable={props.draggable}
            contextMenus={contextMenus}
            onDragStart={(e) => props.onDragStart(e)}
            updateSize ={(id, resizeWidth, resizeHeight) =>  props.updateSize(id, resizeWidth, resizeHeight)}
            errors = {globalState.state.formData.errors.filter(item => item.id == meta.id)[0]}
          />
        );
      case "Button":
        return (
          <Button
            data={meta}
            style={getStyle(meta)}
            onClick={(e) => onClick(e, meta)}
            draggable={props.draggable}
            contextMenus={contextMenus}
            onDragStart={(e) => props.onDragStart(e)}
            updateSize ={(id, resizeWidth, resizeHeight) =>  props.updateSize(id, resizeWidth, resizeHeight)}
          />
        );
      case "ToolBar":
        return (
          <ToolBarMenu
            data={meta}
            style={getStyle(meta)}
            onClick={(e) => onClick(e, meta)}
            draggable={props.draggable}
            contextMenus={contextMenus}
            onDragStart={(e) => props.onDragStart(e)}
            updateSize ={(id, resizeWidth, resizeHeight) =>  props.updateSize(id, resizeWidth, resizeHeight)}
          />
        );
      case "SideBar":
        return (
          <SideBarMenu
            data={meta}
            style={getStyle(meta)}
            onClick={(e) => onClick(e, meta)}
            draggable={props.draggable}
            contextMenus={contextMenus}
            onDragStart={(e) => props.onDragStart(e)}
            updateSize ={(id, resizeWidth, resizeHeight) =>  props.updateSize(id, resizeWidth, resizeHeight)}
          />
        );
      case "DataGrid":
        return (
          <DataGrid
            data={meta}
            isSelected={currentToolIds.includes(meta.id)}
            style={getStyle(meta)}
            draggable={props.draggable}
            contextMenus={contextMenus}
            onDragStart={(e) => props.onDragStart(e)}
            handleOnDrop={(updatedFormData,containerId, template, schema) => 
              props.handleOnDrop(updatedFormData,containerId, template, schema)}
            updateSize ={(id, resizeWidth, resizeHeight) =>  props.updateSize(id, resizeWidth, resizeHeight)}
            onClickPagination ={(pagination) => props.onClickPagination(pagination)}
            onChange={(e, value) => props.onChange(e, value)}
            onKeyPress={(e) => props.onKeyPress(e)}
            onBlur={(e, currentTemplate) => props.onBlur(e, currentTemplate)}
            //onMouseOver={(e, currentTemplate) => props.onMouseOver(e, currentTemplate)}
            onMouseEnter={(e, currentTemplate) => props.onMouseEnter(e, currentTemplate)}
            onMouseDown={(e, currentTemplate) => props.onMouseDown(e, currentTemplate)}
            onMouseLeave={(e, currentTemplate) => props.onMouseLeave(e, currentTemplate)}
            onClick={(e, currentTemplate) => onClick(e, currentTemplate)} // props.onClick(e, currentTemplate)
            onDoubleClick={(e, currentTemplate) => props.onDoubleClick(e, currentTemplate)}
          />
        );
      case "SearchGrid":
        return (
          <SearchGrid
            data={meta}
            isSelected={currentToolIds.includes(meta.id)}
            style={getStyle(meta)}
            contextMenus={contextMenus}
            draggable={props.draggable}
            updateSize ={(id, resizeWidth, resizeHeight) =>  props.updateSize(id, resizeWidth, resizeHeight)}
            onChange={(e, value) => props.onChange(e, value)}
            onKeyPress={(e) => props.onKeyPress(e)}
            onMultiselectionClick={(itemSelected) => props.onMultiselectionClick(itemSelected)}
            onBlur={(e, currentTemplate) => props.onBlur(e, currentTemplate)}
            //onMouseOver={(e, currentTemplate) => props.onMouseOver(e, currentTemplate)}
            onMouseEnter={(e, currentTemplate) => props.onMouseEnter(e, currentTemplate)}
            onMouseDown={(e, currentTemplate) => props.onMouseDown(e, currentTemplate)}
            onMouseLeave={(e, currentTemplate) => props.onMouseLeave(e, currentTemplate)}
            onClickPagination ={(pagination) => props.onClickPagination(pagination)}
            onClick={(e, currentTemplate) => onClick(e, currentTemplate)}/>);
      case "Header":
        return (
          <Header
            data={meta}
            isSelected={currentToolIds.includes(meta.id)}
            style={getStyle(meta)}
            contextMenus={contextMenus}
            draggable={props.draggable}
            updateSize ={(id, resizeWidth, resizeHeight) =>  props.updateSize(id, resizeWidth, resizeHeight)}
            onDropColumn={(e, column) => props.onDropColumn(e, column)}
            onChange={(e, value) => props.onChange(e, value)}
            onKeyPress={(e) => props.onKeyPress(e)}
            onBlur={(e, currentTemplate) => props.onBlur(e, currentTemplate)}
            //onMouseOver={(e, currentTemplate) => props.onMouseOver(e, currentTemplate)}
            onMouseEnter={(e, currentTemplate) => props.onMouseEnter(e, currentTemplate)}
            onMouseDown={(e, currentTemplate) => props.onMouseDown(e, currentTemplate)}
            onMouseLeave={(e, currentTemplate) => props.onMouseLeave(e, currentTemplate)}
            onDoubleClick={(e, currentTemplate) => props.onDoubleClick(e, currentTemplate)}
            onClick={(e, currentTemplate) => onClick(e, currentTemplate)}/>);
      case "Rows":
        return (
          <Rows
            data={meta}
            isSelected={currentToolIds.includes(meta.id)}
            style={getStyle(meta)}
            contextMenus={contextMenus}
            draggable={props.draggable}
            add={props.add}
            delete={props.delete}
            onChange={(e, value) => props.onChange(e, value)}
            onKeyPress={(e) => props.onKeyPress(e)}
            onBlur={(e, currentTemplate) => props.onBlur(e, currentTemplate)}
            //onMouseOver={(e, currentTemplate) => props.onMouseOver(e, currentTemplate)}
            onMouseEnter={(e, currentTemplate) => props.onMouseEnter(e, currentTemplate)}
            onMouseDown={(e, currentTemplate) => props.onMouseDown(e, currentTemplate)}
            onMouseLeave={(e, currentTemplate) => props.onMouseLeave(e, currentTemplate)}
            onClickAdd={(e, index) => props.onClickAdd(e, index)}
            onClickRemove={(index) => props.onClickRemove(index)}
            onClick={(e, currentTemplate) => onClick(e, currentTemplate)}/>);
      case "Row":
        return (
          <Rows
            data={meta}
            isSelected={currentToolIds.includes(meta.id)}
            style={getStyle(meta)}
            contextMenus={contextMenus}
            draggable={props.draggable}
            add={props.add}
            delete={props.delete}
            onChange={(e, value) => props.onChange(e, value)}
            onKeyPress={(e) => props.onKeyPress(e)}
            onBlur={(e, currentTemplate) => props.onBlur(e, currentTemplate)}
            //onMouseOver={(e, currentTemplate) => props.onMouseOver(e, currentTemplate)}
            onMouseEnter={(e, currentTemplate) => props.onMouseEnter(e, currentTemplate)}
            onMouseDown={(e, currentTemplate) => props.onMouseDown(e, currentTemplate)}
            onMouseLeave={(e, currentTemplate) => props.onMouseLeave(e, currentTemplate)}
            onClickAdd={(e, index) => props.onClickAdd(e, index)}
            onClickRemove={(e, index) => props.onClickRemove(e, index)}
            onClick={(e, currentTemplate) => onClick(e, currentTemplate)}/>);
      case "Filter":
        return (
          <Filter
            data={meta}
            isSelected={currentToolIds.includes(meta.id)}
            style={getStyle(meta)}
            contextMenus={contextMenus}
            draggable={props.draggable}
            onChange={(e, value) => props.onChange(e, value)}
            onSelectOperator={(itemSelected) => props.onSelectOperator(itemSelected)}
            onKeyPress={(e) => props.onKeyPress(e)}
            onBlur={(e, currentTemplate) => props.onBlur(e, currentTemplate)}
            //onMouseOver={(e, currentTemplate) => props.onMouseOver(e, currentTemplate)}
            onMouseEnter={(e, currentTemplate) => props.onMouseEnter(e, currentTemplate)}
            onMouseDown={(e, currentTemplate) => props.onMouseDown(e, currentTemplate)}
            onMouseLeave={(e, currentTemplate) => props.onMouseLeave(e, currentTemplate)}
            onClick={(e, currentTemplate) => onClick(e, currentTemplate)}/>);
      default:
        throw new Error();
    }
  };

  return getItem(props.meta);
}
